import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5a337495"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "logo",
  src: "/assets/table-closed.jpg"
}, null, -1))
const _hoisted_2 = { key: 0 }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Veure carta")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_content, {
        class: "ion-padding",
        fullscreen: true
      }, {
        default: _withCtx(() => [
          _createElementVNode("h1", null, _toDisplayString(_ctx.$t("disabledTable.title")), 1),
          _hoisted_1,
          _createElementVNode("p", null, _toDisplayString(_ctx.$t("disabledTable.description")), 1),
          (_ctx.openDate && !_ctx.isOpened)
            ? (_openBlock(), _createElementBlock("p", _hoisted_2, [
                _createElementVNode("b", null, _toDisplayString(_ctx.$t("disabledTable.openDate")) + ": " + _toDisplayString(_ctx.openDate), 1)
              ]))
            : _createCommentVNode("", true),
          (_ctx.isOpened)
            ? (_openBlock(), _createBlock(_component_ion_button, {
                key: 1,
                class: "open-btn",
                color: "primary",
                onClick: _ctx.openLocation
              }, {
                default: _withCtx(() => [
                  _hoisted_3
                ]),
                _: 1
              }, 8, ["onClick"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}